import { FC } from 'react';
import SbEditable from 'storyblok-react';

import { Article, ReleaseSubscriptionCTA } from '../types/Franchises';
import { ContentBlockArtists } from './ContentBlockArtists';
import { ContentBlockBannerList } from './ContentBlockBannerList';
import { ContentBlockHighlight } from './ContentBlockHighlight';
import { ContentBlockImage } from './ContentBlockImage';
import { ContentBlockInsights } from './ContentBlockInsights';
import { ContentBlockInstagram } from './ContentBlockInstagram';
import { ContentBlockItemList } from './ContentBlockItemList';
import { ContentBlockProducts } from './ContentBlockProducts';
import { ContentBlockQuote } from './ContentBlockQuote';
import { ContentBlockSoundCloud } from './ContentBlockSoundCloud';
import { ContentBlockSubscriptionReleases } from './ContentBlockSubscriptionReleases';
import { ContentBlockText } from './ContentBlockText';
import { ContentBlockTweet } from './ContentBlockTweet';
import { ContentBlockVideo } from './ContentBlockVideo';

interface ContentBlocksProps {
  content: Article;
}

export const ContentBlocks: FC<ContentBlocksProps> = ({ content = [] }) => {
  const component = (blok: Article[0]) => {
    switch (blok.component) {
      case 'richText':
        return <ContentBlockText blok={blok} />;
      case 'highlightText':
        return <ContentBlockHighlight blok={blok} />;
      case 'quote':
        return <ContentBlockQuote blok={blok} />;
      case 'multiImage':
        return <ContentBlockImage blok={blok} />;
      case 'inlineVideo':
        return <ContentBlockVideo blok={blok} />;
      case 'itemList':
        return <ContentBlockItemList blok={blok} />;
      case 'bannerList':
        return <ContentBlockBannerList blok={blok} />;
      case 'artistList':
        return <ContentBlockArtists blok={blok} />;
      case 'productList':
        return <ContentBlockProducts blok={blok} />;
      case 'insightList':
        return <ContentBlockInsights blok={blok} />;
      case 'soundCloud':
        return <ContentBlockSoundCloud blok={blok} />;
      case 'twitter':
        return <ContentBlockTweet blok={blok} />;
      case 'instagram':
        return <ContentBlockInstagram blok={blok} />;
      case 'releaseSubscriptionCTA':
        return (
          <ContentBlockSubscriptionReleases
            blok={blok as ReleaseSubscriptionCTA}
          />
        );
      default:
        return null;
    }
  };

  return (
    <article className="flex flex-col gap-y-9 md:gap-y-12">
      {content.map((blok: Article[0]) => (
        // @ts-expect-error require storyblok-react upgrade
        <SbEditable key={blok._uid} content={blok}>
          {component(blok)}
        </SbEditable>
      ))}
    </article>
  );
};
